'use client';

import { useTranslations } from 'next-intl';

import { SearchBar } from 'antd-mobile';

import SearchIcon from '@/assets/svg/search.svg';

interface IDefaultHeaderProps {
    onFocus: () => void;
}

export default function DefaultHeader(props: IDefaultHeaderProps) {
    const { onFocus } = props;
    const t = useTranslations('Discover');

    return (
        <>
            <div className='absolute left-1/2 top-0 h-[400px] w-[375px] -translate-x-1/2 bg-gradient-to-b from-[#9865FF1A] to-[#9865FF00]' />
            <header className='header-search-bar-placeholder relative z-10 h-[52px] w-full items-center px-[16px] py-[8px]'>
                <SearchBar
                    searchIcon={
                        <div className='size-[24px]'>
                            <SearchIcon />
                        </div>
                    }
                    placeholder={t('search_input')}
                    style={{ '--background': '#ffffff', '--border-radius': '52px', '--height': '100%' }}
                    onFocus={onFocus}
                />
            </header>
        </>
    );
}
